var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conetent",class:_vm.headCoverSilde?'slide':'',attrs:{"id":"app"}},[_c('nav-header',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowNav),expression:"isShowNav"}],attrs:{"nav-list":_vm.navList},on:{"slidechange":_vm.headSilde}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85c4fda2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 